import PropTypes from 'prop-types';

const propType = {
  _id: PropTypes.string,
  updatedAt: PropTypes.number,
  createdAt: PropTypes.number,
  name: PropTypes.string,
  deleted: PropTypes.bool,
  viewCount: PropTypes.number,
  highlight: PropTypes.bool,
};

export default { propType };
